import { useState, useEffect } from 'react'
import { User } from '../interfaces/user'
import { API_BASE_URL, X_API_KEY } from '../../services/api'

export const useFetchEstablishments = () => {
  const [data, setData] = useState<User[] | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/all/full`, {
          headers: {
            'x-api-key': X_API_KEY,
          },
        })
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const result = await response.json()
        const filteredUsers = result.users.filter((user: User) =>
          user.status.includes(
            'maison privee, bars et clubs prive, salons de massage, hotels coquins, saunas prives, clubs echangistes, event',
          ),
        )
        setData(filteredUsers)
      } catch (error) {
        setError(error as Error | null)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  return { data, loading, error }
}
